module.exports = __webpack_public_path__ + "media/images/contact_icon-b0be2d9fe1c4dfc656e335ce69d79e47.png";